import React, { useContext, useState, useEffect } from 'react';
import {
	Container,
	Row,
	Col,
	Card,
	CardBody
} from 'reactstrap';
import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';

import { Text } from '~/components/Text';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import { symbolPriceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';
import money from '~/assets/img/money.svg';

import { Pedidos } from '~/components/ExtratoDataSemNotas/Pedidos';
// import { AutorizarSaldo } from '~/components/AutorizarSaldoRevenda';
import { FiltroPedidos } from '~/components/Filtros/FiltroPedidos';
import { DivMontante, ImgMontante, TextMontante } from './styles';

import { ExtratoContext } from '../../../context/ExtratoContext';
import { PedidoContext } from '../../../context/PedidoContext';

function MeusPedidosSemNotas(props) {
	const { user, isMobile } = props;
	// const projetos = ['Iquine', 'Intelbras', 'Testes Lucree', 'Iquine_50', 'Hidracor'];

	const [pagina, setPagina] = useState(1);

	const [toggleAprovar, setToggleAprovar] = useState(false);
	const [toggleVisualizar, setToggleVisualizar] = useState(false);
	const [meusPedidos, setMeusPedidos] = useState([]);
	const [totalItems, setTotalItems] = useState(0);
	const [filtroData, setFiltroData] = useState('');
	const [filtroStatus, setFiltroStatus] = useState('');
	const [filtroPesquisa, setFiltroPesquisa] = useState('');

	const {
		loadingPedido,
		getPedidos,
		dataResumo,
		getResumo,
		// dataSolicitacoes,
		// setDataSolicitacoes
	} = useContext(PedidoContext);

	const { dataSaldo, loadingSaldo } = useContext(ExtratoContext);

	function handlerPagination(page) {
		setPagina(page);
		getPedidos(10, page, 'recebidos', filtroData, filtroStatus, filtroPesquisa).then(res => {
			res?.data?.pedidos && setMeusPedidos(res.data.pedidos);
			res?.data?.total && setTotalItems(res.data.total);
		});
	}

	useEffect(() => {
		if (user.dados.permissoes.view_pgm && user.dados.permissoes.view_labels_pgm_triplo) {
			getResumo(10, 1, '', '');
		}

		getPedidos(10, pagina, 'recebidos', filtroData, filtroStatus, filtroPesquisa).then(res => {
			res?.data?.total && setTotalItems(res.data.total);
			res?.data?.pedidos && setMeusPedidos(res.data.pedidos)
		});
	}, []);

	useEffect(() => {
		if (filtroData || filtroStatus || filtroPesquisa === '' || filtroPesquisa.length > 0) {
			getPedidos(10, pagina, 'recebidos', filtroData, filtroStatus, filtroPesquisa).then(res => {
				res?.data?.total && setTotalItems(res.data.total);
				res?.data?.pedidos && setMeusPedidos(res.data.pedidos)
			});
		}
	}, [filtroData, filtroStatus, filtroPesquisa]);

	return (
		<Container fluid>
			<Row>
				<Col sm="12" md="8" lg="9">
					<Card
						style={{
							backgroundColor: 'transparent',
							boxShadow: 'unset',
							borderRadius: '0px 18px 18px 18px',
						}}>
						<CardBody>
							<Row>
								<></>
								{/* {user.dados.cargo.toLowerCase() === '' && !projetos.includes('Iquine') ? (
									<Col sm="12" md="12" lg="12">
										<Text>AUTORIZAR VISUALIZAÇÃO DE CRÉDITO</Text>
										<AutorizarSaldo
											isMobile={isMobile}
											setDataSolicitacoes={setDataSolicitacoes}
											solicitacoes={dataSolicitacoes && dataSolicitacoes.solicitacoes ? dataSolicitacoes.solicitacoes : []}
											user={user}
											totalItems={dataSolicitacoes ? dataSolicitacoes.total_paginas : 1} />
									</Col>
								) : (
									<></>
								)} */}
							</Row>
						</CardBody>
					</Card>
				</Col>
				<Col sm="12" md="4" lg="3">
					<Text style={{ textAlign: 'right' }}>Meus Créditos</Text>
					<Card
						style={{
							marginBottom: 0,
							backgroundColor: color.secondary,
						}}>
						<CardBody className="py-4 px-2">
							<DivMontante>
								{loadingSaldo ? (
									<LoaderMini />
								) : (
									<>
										<TextMontante
											style={{ marginRight: '5%' }}>
											<Text
												color="softBlack"
												size="big">
												{symbolPriceFormatter(
													user.dados.permissoes.view_labels_pgm_triplo ? dataResumo.montante || 0 : dataSaldo.saldo || 0
												)}
											</Text>
										</TextMontante>
										<ImgMontante
											alt="money"
											width="20"
											src={money}
										/>
									</>
								)}
							</DivMontante>
						</CardBody>
					</Card>
				</Col>
			</Row>
			<Row className="mt-5">
				<Col>
					<Text>APROVAÇÕES DE LANÇAMENTOS</Text>
					<FiltroPedidos
						user={user}
						setFiltroData={setFiltroData}
						setFiltroStatus={setFiltroStatus}
						filtroStatus={filtroStatus}
						setPagina={setPagina}
						setFiltroPesquisa={setFiltroPesquisa}
					/>

					<LoaderLista loading={!loadingPedido} lista={meusPedidos}>
						<Pedidos
							setPagina={setPagina}
							pagina={pagina}
							setMeusPedidos={setMeusPedidos}
							toggleAprovar={toggleAprovar}
							setToggleAprovar={setToggleAprovar}
							toggleVisualizar={toggleVisualizar}
							setToggleVisualizar={setToggleVisualizar}
							lancamentos={meusPedidos}
							isDistribuidor={user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor'}
							user={user}
							loadingPedido={loadingPedido}
							filtroStatus={filtroStatus}
							filtroData={filtroData}
							filtroPesquisa={filtroPesquisa}
						/>
						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							<Pagination
								activePage={pagina}
								totalItemsCount={totalItems}
								onChange={(page) => handlerPagination(page)}
								prevPageText={<ChevronLeftOutlined />}
								nextPageText={<ChevronRightOutlined />}
								firstPageText={<FirstPageOutlined />}
								lastPageText={<LastPageOutlined />}
							/>
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}

export default MeusPedidosSemNotas;

